import vue from "../main";

export const documentTypeEnum = Object.freeze({
  DOCUMENT_TYPE_GENERAL: 0,
  DOCUMENT_TYPE_DELEGATION: 1,
  DOCUMENT_TYPE_DELEGATION_ORDER: 2
});

export function documentType() {
  return [
    {
      value: documentTypeEnum.DOCUMENT_TYPE_GENERAL,
      text: vue.$t("$staticData.documentNumberTemplate.documentType.generalDocument")
    },
    {
      value: documentTypeEnum.DOCUMENT_TYPE_DELEGATION,
      text: vue.$t("$staticData.documentNumberTemplate.documentType.delegation")
    },
    {
      value: documentTypeEnum.DOCUMENT_TYPE_DELEGATION_ORDER,
      text: vue.$t("$staticData.documentNumberTemplate.documentType.delegationOrder")
    }
  ];
}

export function numberType() {
  return [
    {
      value: 0,
      text: vue.$t("$staticData.documentNumberTemplate.numberType.basedOnMask")
    },
    {
      value: 1,
      text: vue.$t("$staticData.documentNumberTemplate.numberType.monthly")
    },
    {
      value: 2,
      text: vue.$t("$staticData.documentNumberTemplate.numberType.monthlyNationalSeparated")
    },
    {
      value: 3,
      text: vue.$t("$staticData.documentNumberTemplate.numberType.yearly")
    },
    {
      value: 4,
      text: vue.$t("$staticData.documentNumberTemplate.numberType.yearlyNationalSeparated")
    },
    {
      value: 5,
      text: vue.$t("$staticData.documentNumberTemplate.numberType.static")
    },
    {
      value: 6,
      text: vue.$t("$staticData.documentNumberTemplate.numberType.staticNationalSeparated")
    }
  ];
}
